import { useState } from "react";
import { Button } from "../ui/button";
import { CreditCard, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

/**
 * Reusable button to start a Stripe Checkout for a specific item.
 * Props:
 *  - kind: "installment" | "tournament_fee" | "tournament_meal"
 *  - itemId: string
 *  - subId: optional string (rate index for installments)
 *  - label: optional button label
 *  - size, variant, className: passed through
 */
export default function PayNowButton({ kind, itemId, subId, label = "Paga", size = "sm", variant = "outline", className = "", testId }) {
  const [loading, setLoading] = useState(false);

  const start = async (e) => {
    e?.stopPropagation?.();
    setLoading(true);
    try {
      const { data } = await api.post(`/payments/checkout-session`, {
        kind,
        item_id: itemId,
        sub_id: subId,
        origin_url: window.location.origin,
      });
      if (data?.url) {
        window.location.href = data.url;
      } else {
        toast.error("Impossibile avviare il pagamento");
      }
    } catch (err) {
      const msg = err?.response?.data?.detail || "Errore avvio pagamento";
      toast.error(msg);
      setLoading(false);
    }
  };

  return (
    <Button size={size} variant={variant} className={className} onClick={start} disabled={loading} data-testid={testId}>
      {loading ? <Loader2 size={12} className="mr-1 animate-spin" /> : <CreditCard size={12} className="mr-1" />}
      {loading ? "Apertura..." : label}
    </Button>
  );
}
